import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';
import { fmtDate } from '../../../../utils/fmt';

const CustomerInteractionList = () => {
  const { customerId } = useParams();

  const decodedCustomerId = customerId ? atob(customerId).replace(/\D/g, '') : '';
  const fetchUrl = decodedCustomerId
    ? `${API_DOMAIN}${API_ROUTES.customerInteraction}?customer=${decodedCustomerId}`
    : `${API_DOMAIN}${API_ROUTES.customerInteraction}`;

  const columns = [
    { label: 'Date', value: (item) => fmtDate(item.date) },
    { label: 'Interaction Type', value: 'interaction_type' },
    { label: 'Outcome', value: 'outcome' },
    {
      label: 'Customer',
      value: (item) => item.customer?.name || 'Unknown'
    },
    {
      label: 'Handler',
      value: (item) => item.handler?.username || 'Unknown'
    },
  ];

  const handleAccessDetails = (customerId) => {
    const encodedId = btoa(customerId);
    window.location.href = `/customer/interactions/details/${encodedId}`;
  };

  return (
    <div>
      <h1>Customer Interactions</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default CustomerInteractionList;
